import React, { createContext } from 'react';
import {
  Box, Button, ButtonText, Center, Text,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

export type WaitingBedMuteControls = {
  show: boolean;
  bedMuted: boolean;
  onToggle: () => void;
};

/** Lets the dry-run bar host the mute control instead of floating over it. */
export const WaitingBedMuteContext = createContext<WaitingBedMuteControls | null>(null);

type WaitingLoungeAtmosphereChromeProps = {
  showBedMute: boolean;
  bedMuted: boolean;
  onToggleBedMute: () => void;
  overlayVisible: boolean;
  /** Dry-run banner draws the mute control in the bar. */
  hostMuteInBanner?: boolean;
};

export function WaitingBedMuteButton({
  bedMuted,
  onToggle,
}: {
  bedMuted: boolean;
  onToggle: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Button
      size="sm"
      variant="outline"
      onPress={onToggle}
      testID="oral-exam-waiting-bed-mute"
    >
      <ButtonText>
        {bedMuted
          ? t('oralExam.lobby.waiting.unmuteBed')
          : t('oralExam.lobby.waiting.muteBed')}
      </ButtonText>
    </Button>
  );
}

/**
 * Bed mute control and the pre-briefing fade overlay for cohort waiting.
 */
export function WaitingLoungeAtmosphereChrome({
  showBedMute,
  bedMuted,
  onToggleBedMute,
  overlayVisible,
  hostMuteInBanner = false,
}: WaitingLoungeAtmosphereChromeProps) {
  const { t } = useTranslation();

  return (
    <>
      {showBedMute && !hostMuteInBanner ? (
        <Box position="absolute" top="$4" right="$4" zIndex={20}>
          <WaitingBedMuteButton bedMuted={bedMuted} onToggle={onToggleBedMute} />
        </Box>
      ) : null}
      {overlayVisible ? (
        <Center
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="$bgOverlay"
          zIndex={30}
          testID="oral-exam-leaving-preflight-overlay"
        >
          <Text size="lg" fontWeight="semibold" color="$textInverted" textAlign="center" px="$6">
            {t('oralExam.lobby.waiting.groupBriefingStarting')}
          </Text>
        </Center>
      ) : null}
    </>
  );
}
